import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '@/Store/Slices/ModalSlice';
import { useForm } from '@inertiajs/inertia-react';

const MultipleActionModal = ({ids, url, text, id}) => {
  const dispatch = useDispatch()
  const { data, setData, post } = useForm({
    ids,
    pageParams: {},

    // NOTE: When working with Laravel PUT/PATCH requests and FormData
    // you SHOULD send POST request and fake the PUT request like this.
    _method: 'POST'
  });


  useEffect(() => {
    const url = new URL(window.location.href);
    const params = Object.fromEntries(url.searchParams.entries());
    if (!!params) setData('pageParams', params)
  }, [])



  const handlePublishCoupon = () => {
    if (id) {
      post(route(url, id).url(), data)
    } else {
      post(route(url).url(), data)
    }

    dispatch(closeModal())
  }

  return (
    <>
      <div className='modal-body'>
        {text}
      </div>
      <div className="modal-footer flex justify-end">
        <button onClick={handlePublishCoupon} className="btn-default bg-green-700 focus:outline-none py-2 px-4">
          <span>Yes</span>
        </button>
      </div>
    </>
  );
};

export default MultipleActionModal;
